module.exports = new __parcel__URL__("telia-logo-reversed.689ef1ec.png").toString();